import "@PrivateArea/Styles/Main.less"

import BasePage from "@PrivateArea/Scripts/Pages/BasePage";
import DataWebPage from "@PrivateArea/Scripts/Pages/DataWebPage";
import AssetDetailPage from "@PrivateArea/Scripts/Pages/AssetDetailPage";
import AssetViewerPage from "@PrivateArea/Scripts/Pages/AssetViewerPage";
import ProcessAssetDetailPage from "@PrivateArea/Scripts/Pages/ProcessAssetDetailPage";

let App: any = {
    instances: {},
    pages: {},
    routes: {},
    viewModels: {},
    resources: {}
};

App.pages.BasePage = BasePage;
App.pages.DataWebPage = DataWebPage;
App.pages.AssetDetailPage = AssetDetailPage;
App.pages.AssetViewerPage = AssetViewerPage;
App.pages.ProcessAssetDetailPage = ProcessAssetDetailPage;

(<any>window).App = App;